{
  "loading": "Načítava sa...",
  "placeholder": "Vyberte možnosť..."
}
